import {findSection, updateSectionValue} from 'ducks/reportSections';
import {connect} from 'react-redux';
import CustomiseSuburbProfile from 'components/CustomiseSuburbProfile';
import {updatePreferences} from 'actionCreators/preferences';
import isArray from 'lodash/isArray';
import {titleCase} from 'lib/StringUtils';

const mapStateToProps = (state) => {
  const reportType = state.reportType.value;
  return {
    section: findSection(state.reportSections, reportType, 'SUBURB_PROFILE'),
    suburbName: titleCase(state.propertyDetail.localityName),
    suburbInsights: state.propertyDetail.suburbInsights,
    propertyType: state.propertyDetail.propertyType,
    reportType,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onUpdateSectionValue: (value, dataKeyPath, reportType) => {
      dispatch(updateSectionValue({
        value,
        reportType,
        key: 'SUBURB_PROFILE',
        dataKeyPath,
      }));
      dispatch(updatePreferences({[`suburbProfile.${dataKeyPath}`]: isArray(value) ? value.join(',') : value}, reportType));
    },
  };
};

const mergeProps = (stateProps, dispatchProps) => {
  return {
    ...stateProps,
    ...dispatchProps,
    onUpdateSectionValue: (value, dataKeyPath) => {
      dispatchProps.onUpdateSectionValue(value, dataKeyPath, stateProps.reportType);
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(CustomiseSuburbProfile);
